import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainPointSection } from './components/PainPointSection';
import { ProblemSection } from './components/ProblemSection';
import { IntroSection } from './components/IntroSection';
import { ServicesSection } from './components/ServicesSection';
import { WhyChooseUsSection } from './components/WhyChooseUsSection';
import { ImagineSection } from './components/ImagineSection';
import { ProjectGallery } from './components/ProjectGallery';
import { ServiceAreaMap } from './components/ServiceAreaMap';
import { StepsSection } from './components/StepsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { FloatingMessageButton } from './components/FloatingMessageButton';
export function App() {
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-[#1B4332] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPointSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <IntroSection data-id="element-6" />
        <ServicesSection data-id="element-7" />
        <WhyChooseUsSection data-id="element-8" />
        <ImagineSection data-id="element-9" />
        <ProjectGallery data-id="element-10" />
        <ServiceAreaMap data-id="element-11" />
        <StepsSection data-id="element-12" />
        <CTASection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <FloatingMessageButton data-id="element-15" />
    </div>;
}